export default __webpack_public_path__ + "static/media/click.db461987.mp3";